const constants = {
  baseSpacing: 24,
  halfSpacing: 12,
  quarterSpacing: 6,
  colors: {
    red: '#ED1B2E',
    lightRed: '#d6606b',
    darkRed: '#C41827',
    lightGrey: '#EEEEED',
    midGrey: '#CCCCCB',
    darkerMidGrey: '#999999',
    darkGrey: '#303B3F',
    darkerGrey: '#22292C',
    darkestGrey: '#273033',
    blue: '#1093B9',
    lightBlue: '#609CD6',
    darkBlue: '#24496C',
    yellow: '#EAB449',
    orange: '#FF9900',
    lightOrange: '#EAB449',
    lightGreen: '#8CC75E',
    offBlack: '#111516',
    offWhite: '#FDFDFD',
    placeholder: '#E4E4E3',
    sohoLightGray: '#99A1AA',
    sohoGray: '#455568',
    sohoGray3: '#C4C8CC',
    sohoGreen: '#43A97C',
    sohoBlue: '#1093B9'
  },
  modalSizes: {
    wide: '70rem',
    narrow: '22rem',
    default: '45rem'
  },
  radius: 3,
  transition: '0.33s'
};

export const creditGridTemplateColumns = '100px 2fr 2fr 2fr 200px 90px';
export const creditGridTemplateColumnsNoGroup = '100px 2fr 2fr 2fr 90px';

export const {
  baseSpacing,
  halfSpacing,
  quarterSpacing,
  colors,
  modalSizes,
  radius,
  transition
} = constants;

export default constants;
